import { motion } from "framer-motion";

// Reveals text one word at a time with a subtle upward/opacity ease.
// `wordClassName` gets applied to each individual word span — useful for
// gradient text where background-clip must be on the text-bearing element.
const RevealText = ({ text, className = "", wordClassName = "", stagger = 0.06, delay = 0, as = "span" }) => {
    const words = text.split(" ");
    const container = {
        hidden: {},
        visible: {
            transition: { staggerChildren: stagger, delayChildren: delay }
        }
    };
    const child = {
        hidden: { opacity: 0, y: 20, filter: "blur(6px)" },
        visible: {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] }
        }
    };
    const Comp = motion[as] || motion.span;
    return (
        <Comp className={className} variants={container} initial="hidden" animate="visible">
            {words.map((w, i) => (
                <span key={i} className="inline-block overflow-hidden align-baseline">
                    <motion.span
                        variants={child}
                        className={`inline-block will-change-transform ${wordClassName}`}
                    >
                        {w}
                        {i < words.length - 1 ? "\u00A0" : ""}
                    </motion.span>
                </span>
            ))}
        </Comp>
    );
};

export default RevealText;
